import {
	baseUrl
} from './env'
import md5 from 'js-md5';
export let appKey = "0136652484";
let scret = '6D9D23399E4BF100FB8F93CC9160D511';
import axios from 'axios'
import { Loading , Message} from 'element-ui';
import {getCookie,delCookie} from '../utils'
export  default async(url = '', data = {}, type = 'GET', method = 'fetch') => {
    url = baseUrl+url
    let timestamp = Date.parse(new Date())
		let requestConfig =  {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Timestamp':timestamp,
            'Sign':sign(appKey,timestamp),
            //'Sign':'7206C39584DBEDFB11882980E1890012',
            'APP-Key':appKey,
            'Authorization':localStorage.getItem('mgt_user')?localStorage.getItem('mgt_user').replace(/\"/g, ""):'',
            //  "Authorization":'70EFDF2EC9B086079795C442636B55FB.67494450003b4254b907e200f2e8bd28'
        };
        return new Promise((resolve, reject) => {
            // $.ajax({
            //     url:url,
            //     data:data,
            //     type:type,
            //     headers:requestConfig,
            //     success:(data)=>{
            //         console.log(data)
            //         resolve(data)
            //     },
            //     fail:(data)=>{
            //         console.log(data)
            //         reject(data)
            //     }
            // })
            axios.get(url, {
                params:data,
                headers:requestConfig,
                responseType: 'blob', //二进制流
            }).then(function (res) {
                resolve(res)
            }).catch(function (error) {
                reject(error)
                console.log(error)
            });
       
        })
}


export function sign( appKey, timestamp) {
	let serial = joinParamStr(appKey,timestamp);
	let sign = md5(md5(serial).toUpperCase() + scret).toUpperCase();
	return sign;
}


export function joinParamStr( appKey, timestamp){
	let sb = "appKey="+appKey+"&timestamp="+timestamp
	return sb;
}


// WEBPACK FOOTER //
// ./src/config/ajax.js